import { CanActivate, Router} from '@angular/router';
import { AppSettings } from '../shared/app-settings';
import { Observable, from, of } from 'rxjs';
import { Storage } from '@ionic/storage-angular';
import { switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService as AuthTokenService } from '../services/auth.service';

@Injectable()
export class AuthService implements CanActivate {
    constructor(
        private router: Router, 
        private storage: Storage,
        private authTokenService: AuthTokenService
    ) { }
    
    canActivate(): Observable<boolean> {
        // Check if user is authenticated (will try refresh token if access token expired)
        return from(this.authTokenService.isLoggedIn()).pipe(
            switchMap(isLoggedIn => {
                if (isLoggedIn) {
                    return of(true);
                }
                // Only redirect if not already on login page
                if (!this.router.url.includes('/login')) {
                    console.warn('[AUTH-GUARD] User not authenticated, redirecting to login');
                    this.router.navigate(['/login'], { replaceUrl: true });
                }
                return of(false);
            })
        );
    }
}
